export const BLOCK_CARD_OTP_SUCCESS = '/YscCardActions/BLOCK_CARD_OTP_SUCCESS';
export const BLOCK_CARD_SUCCESS = '/YscCardActions/BLOCK_CARD_SUCCESS';
export const BLOCK_CARD_VALIDATION_MESSAGE = 'Please Validate to Permanently Block Your Card.';
export const LOCK_CARD_VALIDATION_MESSAGE = 'Please Validate to Lock Your Card Temporarily.';
export const UNLOCK_CARD_VALIDATION_MESSAGE = 'Please Validate to Unlock Your Card.';
export const BLOCK_CARD_PATH = '/ysc/block-card';
export const LOCK_CARD_PATH = '/ysc/lock-card';

const YSCCARD_CONSTANTS = Object.freeze({
  BLOCK_CARD_WARNING_MESSAGE: 'This Card will be Blocked Permanently.',
  LOCK_CARD_WARNING_MESSAGE: 'This Card will be Locked Temporarily.',
  UNLOCK_CARD_WARNING_MESSAGE: 'This Card will be Unlocked',
  CUSTOMER_SERVICE: 'Customer Service Number',
  CUSTOMER_SERVICE_NUMBER: '1860 500 1231',
  CUSTOMER_SERVICE_TIMINGS: 'Timings - Monday to Saturday ( 10 AM - 7 PM)',
});

const radioOptions = [
  { value: 'BL', label: 'Block the Card due to Card Lost' },
  { value: 'BS', label: 'Block the Card due to Card Stolen' },
  { value: 'BD', label: 'Block the Card due to Physical Damage' },
];

export { YSCCARD_CONSTANTS, radioOptions };



// WEBPACK FOOTER //
// client/containers/YscCardActions/constants.js